
import React, { useState, useEffect } from 'react'
import * as XLSX from 'xlsx'
import constants from '../../constants/constants'
import { CommaSeparator } from '../../functions'
const DownloadSCV = ({
    data,
    setIsSVGDownload
}) => {


    let tempList = [[
        constants.EconomicCode,
        constants.MobileNumber,
        constants.DatePAyment,
        constants.NationalCode,
        constants.PostalCode,
        constants.Address,
        constants.City,
        // constants.Date,
        constants.FactorNumber,
        // constants.Personality,
        constants.CompanyName,
        constants.Family,
        constants.DescriotionFactor,
        constants.ReferenceNumber,
        constants.MoadianStatus,
        constants.SayPrice,
        constants.DiscountPrice,
        constants.RealPrice,
        constants.Tax,
        constants.Toll,
        constants.Totall
    ]]
    //******************************************************************************* */
    useEffect(() => {

        data.data.map((item, index) => {
            let arr = []
            arr.push(item?.FactorIssueType === 2 ? item?.CompanyEconomicCode : '---')

            arr.push(item?.Mobile ?? '---')

            arr.push(item?.PersianIssueDate ?? '---')

            //national code
            arr.push(item?.FactorIssueType === 2 ? item?.NationalCompanyRegistrationNumber : item?.NationalCode !== null ? item?.NationalCode : '---')

            //residentPOstalCode
            arr.push(item?.FactorIssueType === 2 ? item?.WorkPostalCode : item?.ResidencePostalCode !== null ? item?.ResidencePostalCode : '---')

            //workAddress
            arr.push(item?.FactorIssueType === 2 ? item?.WorkAddress : item?.ResidenceAddress !== null ? item?.ResidenceAddress : '---')

            arr.push(item?.CityName ?? '---')
            arr.push(item?.InvoiceNumberInFactor ?? '---')

            //company name
            arr.push(item?.FactorIssueType === 2 ? item?.CompanyName : '---')

            arr.push(item?.FactorIssueType === 1 ? item?.FirstNameAndLastName !== null ? item?.FirstNameAndLastName : '---' : '---')



            // arr.push(item?.FirstNameAndLastName ?? '---')
            arr.push(item?.InvoiceItemDescription ?? '---')
            arr.push((item?.MoadianTaxId !== '' && item?.MoadianTaxId !== null) ? item?.MoadianTaxId : '---')
            arr.push((item?.MoadianStatus !== '' && item?.MoadianStatus !== null) ?
                item?.MoadianStatus === 'SUCCESS' ? 'تایید شده' :
                    item?.MoadianStatus === 'FAILED' ? 'رد شده' :
                        item?.MoadianStatus !== 'FAILED' && item?.MoadianStatus !== 'SUCCESS' ? 'در حال بررسی' : '---'
                : '---')

            arr.push((item?.TotalBeforeVAT || item?.TotalBeforeVAT === 0) ? CommaSeparator(item?.TotalBeforeVAT) : 0)
            arr.push((item?.totalDiscount || item?.totalDiscount === 0) ? CommaSeparator(item?.totalDiscount) : 0)
            arr.push((item?.PayableAmount || item?.PayableAmount === 0) ? CommaSeparator(item?.PayableAmount) : 0)
            arr.push((item?.Duty || item?.Duty === 0) ? CommaSeparator(item?.Duty) : 0)
            arr.push((item?.Tax || item?.Tax === 0) ? CommaSeparator(item?.Tax) : 0)
            arr.push((item?.Subtotal || item?.Subtotal === 0) ? CommaSeparator(item?.Subtotal) : 0)

            tempList.push(arr)
        })
        setIsSVGDownload(false)
    }, [])
    //******************************************************************************** */
    useEffect(() => {
        const worksheet = XLSX.utils.json_to_sheet(tempList);
        XLSX.utils.json_to_sheet(tempList);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "DataSheet.xlsx");
    }, [])
    //******************************************************************************** */
    return (<>
    </>)
}

export default DownloadSCV